<script setup>
import { useI18n } from 'vue-i18n';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import AvailabilitySettings from 'dashboard/components-next/AgentAvailability/AvailabilitySettings.vue';

const { t } = useI18n();
</script>

<template>
  <div class="grid max-w-2xl ltr:mr-auto rtl:ml-auto">
    <BaseSettingsHeader
      :title="t('AGENT_AVAILABILITY.TITLE')"
      :description="t('AGENT_AVAILABILITY.DESCRIPTION')"
    />
    <div class="pt-2">
      <AvailabilitySettings />
    </div>
  </div>
</template>
